module.exports = __webpack_public_path__ + "img/Services.7d63a012.png";